import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip
);

const EquityChart = ({ data }) => {
  function calculateCumulativePnl(data) {
    // Aggregate data by date
    const aggregatedData = {};
    for (const entry of data) {
      if (!aggregatedData[entry.date]) {
        aggregatedData[entry.date] = 0;
      }
      aggregatedData[entry.date] += entry.new_pnl;
    }

    // Calculate cumulative pnl
    const cumulativePnl = [];
    let cumulativeSum = 0;
    Object.entries(aggregatedData)
      .sort()
      .forEach(([date, pnl]) => {
        cumulativeSum += pnl;
        cumulativePnl.push({ date, cumm_pnl: cumulativeSum });
      });

    return cumulativePnl;
  }

  const newdata = calculateCumulativePnl(data);

  const chartData = {
    labels: newdata.map((entry) => entry.date),
    datasets: [
      {
        data: newdata.map((entry) => entry.cumm_pnl),
        backgroundColor: "transparent",
        borderColor: "#07f2c7",
        pointBorderColor: "transparent",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        titleColor:"#fff",
        bodyColor:"#07f2c7",
        displayColors:true,
        bodyFont:{
          size:16
        },
        bodySpacing:8,
        padding:6

      },
    },
    scales: {
      x: {
        grid: {
          display: true,
          color:"#171717"
        },
        ticks: {
          padding: 20,
          maxTicksLimit:10
      }
      },
      y: {
        grid: {
          display:true,
          color:"#171717",
          borderDash: [10],
        },
        ticks: {
          padding: 10,
      }
      },
    },
  };

  return (
    <div className="w-[800px] h-[400px]">
      <Line data={chartData} options={chartOptions}  />
    </div>
  );
};

export default EquityChart;
